<script setup>
import { computed, watch } from 'vue'
import { useStore } from 'vuex'
import { useUnleashContext } from '@unleash/proxy-client-vue'
import * as Sentry from '@sentry/vue'
import { LoadingComponent } from '@/ui-library'
import router from '@/router'
import { initializeBannedUserChannel } from '@/services/banned-user.service'

const { getters } = useStore()
const user = computed(() => getters['user/loggedUser'])
const isLoading = computed(() => getters['user/isLoading'])
const updateContext = useUnleashContext()

initializeBannedUserChannel(() => {
  router.push({ name: 'no-access', query: { reason: 'banned' } })
})

watch(user, (newValue, oldValue) => {
  if (newValue?.id && newValue?.id !== oldValue?.id) {
    updateContext({
      userId: newValue.id,
      properties: { userEmail: newValue.email, locale: newValue.locale },
    })

    Sentry.setUser({ id: String(newValue.id) })
  }
})
</script>

<template>
  <div class="app-wrapper">
    <template v-if="!isLoading">
      <router-view />
    </template>
    <LoadingComponent v-else is-full-size :size="96" />
  </div>
</template>
<style scoped lang="scss">
.app-wrapper {
  min-height: 100vh;
  padding-left: 80px;
  padding-top: 72px;
}
</style>
